var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3125 14.5171L11.0645 10.269C12.0852 9.04354 12.5943 7.47169 12.4856 5.88047C12.377 4.28924 11.6591 2.80115 10.4812 1.72576C9.30339 0.650366 7.75628 0.0704698 6.16177 0.106704C4.56725 0.142938 3.04808 0.792512 1.9203 1.9203C0.792512 3.04808 0.142938 4.56725 0.106704 6.16177C0.0704698 7.75628 0.650366 9.30339 1.72576 10.4812C2.80115 11.6591 4.28924 12.377 5.88047 12.4856C7.47169 12.5943 9.04354 12.0852 10.269 11.0645L14.5171 15.3125L15.3125 14.5171ZM1.25001 6.31251C1.25001 5.31124 1.54692 4.33246 2.1032 3.49994C2.65947 2.66741 3.45013 2.01854 4.37518 1.63537C5.30023 1.2522 6.31813 1.15195 7.30016 1.34729C8.28218 1.54262 9.18424 2.02478 9.89224 2.73278C10.6002 3.44079 11.0824 4.34284 11.2777 5.32487C11.4731 6.3069 11.3728 7.32479 10.9897 8.24985C10.6065 9.1749 9.95761 9.96555 9.12508 10.5218C8.29256 11.0781 7.31378 11.375 6.31251 11.375C4.97031 11.3735 3.68351 10.8397 2.73443 9.89059C1.78535 8.94151 1.2515 7.65471 1.25001 6.31251Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.3c14f5a607c94500bd0d2379d58286b4.svg";
export { ForwardRef as ReactComponent };